export default [
  {
    name: 'admin-broadcast-messages',
    icon: 'mdi-bell',
    path: '/admin/broadcast-messages',
    component: () =>
      import(/* webpackChunkName: "admin-broadcast-messages" */ './views/BroadcastMessageList.vue'),
    meta: {
      admin: true,
      allowedRoles: ['superadmin'],
      adminToolbar: false,
      adminDrawer: true,
    },
  },
];
